import React, { useContext } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import Header from './components/Header.js'
import Footer from './components/Footer.js'
import HomeScreen from './screens/HomeScreen.js'
import LoginScreen from './screens/LoginScreen.js'
import About from './screens/About.js'
import ContactScreen from './screens/ContactScreen.js'
import RegisterScreen from './screens/RegisterScreen.js'
import DashBoard from './screens/DashBoard.js'
import ChartScreen from './screens/ChartScreen.js'
import ReportsScreen from './screens/ReportsScreen.js'
import ReceiptScreen from './screens/ReceiptScreen.js'
import ProfileScreen from './screens/ProfileScreen.js'
import SearchBox from './components/SearchBox.js'
import ReceiptUpdateScreen from './screens/ReceiptUpdateScreen.js'
import CatReceiptScreen from './screens/CatReceiptScreen.js'
import UserListScreen from './screens/UserListScreen.js'
import UserEditScreen from './screens/UserEditScreen.js'
import BusinessRegisterScreen from './screens/BusinessRegister.js'
import OwnerLoginScreen from './screens/OwnerLoginScreen.js'
import OwnerDashBoard from './screens/OwnerDashboard.js'
import OwnerProfileScreen from './screens/OwnerProfileScreen.js'
import ApiDocument from './screens/ApiDocument.js'
import ReceiptChartScreen from './screens/ReceiptChartScreen.js'
import PremiumScreen from './screens/PremiumScreen.js'
import { ThemeProvider, ThemeContext } from './components/ThemeContext.js'

const AppRoutes = () => {
  const { theme } = useContext(ThemeContext)

  return (
    <div
      style={{
        backgroundColor: theme.bg,
        color: theme.text,
        minHeight: '100vh'
      }}
    >
      <main className={theme}>
        <Container className='py-3'>
          <Header />
          <Routes>
            <Route path='/' element={<HomeScreen />} />
            <Route path='/about' element={<About />} />
            <Route path='/contact' element={<ContactScreen />} />
            <Route path='/login' element={<LoginScreen />} />
            <Route path='/ownerlogin' element={<OwnerLoginScreen />} />
            <Route path='/register' element={<RegisterScreen />} />
            <Route path='/admin/user/register' element={<RegisterScreen />} />
            <Route
              path='/businessregister'
              element={<BusinessRegisterScreen />}
            />
            <Route path='/receipts' element={<ReceiptScreen />} />
            <Route path='/category' element={<CatReceiptScreen />} />
            <Route path='/receipts/:id' element={<ReceiptScreen />} />
            <Route
              path='/receipts/edit/:id'
              element={<ReceiptUpdateScreen />}
            />
            <Route path='/dashboard' element={<DashBoard />} />
            <Route path='/ownerdashboard' element={<OwnerDashBoard />} />
            <Route path='/charts' element={<ChartScreen />} />
            <Route path='/reports' element={<ReportsScreen />} />
            <Route path='/profile' element={<ProfileScreen />} />
            <Route path='/ownerprofile' element={<OwnerProfileScreen />} />
            <Route path='/search/:keyword' element={<ReceiptScreen />} />
            <Route path='/page/:pageNumber' element={<ReceiptScreen />} />
            <Route
              path='/catpage/:catpageNumber'
              element={<CatReceiptScreen />}
            />
            <Route path='/search' element={<SearchBox />} />
            <Route path='*' element={<h1>404 Not Found</h1>} />
            <Route path='/userlist' element={<UserListScreen />} />
            <Route path='/modifyuser/:id' element={<UserEditScreen />} />
            <Route path='/apidocument' element={<ApiDocument />} />
            <Route path='/receiptchart' element={<ReceiptChartScreen />} />
            <Route path='/premium' element={<PremiumScreen />} />
          </Routes>
          <Footer />
        </Container>
      </main>
    </div>
  )
}

const App = () => {
  return (
    <ThemeProvider>
      <AppRoutes />
    </ThemeProvider>
  )
}

export default App
